import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { apiGet } from '../utils/api';
import { swalertConfirm } from '../utils/notifications';
import logoSimple from '../img/sogacsa-simple.png';
import logoCompleto from '../img/sogacsa.png';
import './Navbar.scss';

export default function NavigationBar(props) {
    const logo = props.min ? logoCompleto : logoSimple;

    const solicitudes = (
        <NavDropdown title="Solicitudes" id="basic-nav-dropdown">
            <LinkContainer to="/solicitar/vacaciones"><NavDropdown.Item>Vacaciones</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/solicitar/bajas"><NavDropdown.Item>Bajas</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/solicitar/permisos"><NavDropdown.Item>Permisos</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/solicitar/vestimenta"><NavDropdown.Item>Vestimenta</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/solicitar/horasextra"><NavDropdown.Item>Horas extra</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/solicitar/gastos"><NavDropdown.Item>Gastos</NavDropdown.Item></LinkContainer>
        </NavDropdown>
    );
    const validaciones = (
        <NavDropdown title="Validaciones" id="basic-nav-dropdown">
            <LinkContainer to="/validar/vacaciones"><NavDropdown.Item>Vacaciones</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/validar/bajas"><NavDropdown.Item>Bajas</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/validar/permisos"><NavDropdown.Item>Permisos</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/validar/horasextra"><NavDropdown.Item>Horas extra</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/validar/gastos"><NavDropdown.Item>Gastos</NavDropdown.Item></LinkContainer>
        </NavDropdown>
    );
    const vestuario = (
        <NavDropdown title="Vestuario" id="basic-nav-dropdown">
            <LinkContainer to="/vestuario/prendas"><NavDropdown.Item>Prendas</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/vestuario/solicitudes"><NavDropdown.Item>Solicitudes de vestimenta</NavDropdown.Item></LinkContainer>
        </NavDropdown>
    );
    const supervision = (
        <NavDropdown title="Supervisión" id="basic-nav-dropdown">
            <LinkContainer to="/supervisar/diasLibres"><NavDropdown.Item>Días Libres</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/supervisar/diasVacaciones"><NavDropdown.Item>Días Vacaciones</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/supervisar/fichajes"><NavDropdown.Item>Fichajes</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/supervisar/permisosFichaje"><NavDropdown.Item>Permisos Fichaje</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/supervisar/hojasdefichaje"><NavDropdown.Item>Hojas de fichaje</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/supervisar/descargarhojas"><NavDropdown.Item>Descargar hojas firmadas</NavDropdown.Item></LinkContainer>
        </NavDropdown>
    );
    const admin = (
        <NavDropdown title="Admin" id="basic-nav-dropdown">
            <LinkContainer to="/admin/usuarios"><NavDropdown.Item>Usuarios</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/admin/departamentos"><NavDropdown.Item>Departamentos</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/admin/convenios"><NavDropdown.Item>Convenios</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/admin/localidades"><NavDropdown.Item>Localidades</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/admin/prendas"><NavDropdown.Item>Prendas</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/admin/clientes"><NavDropdown.Item>Clientes</NavDropdown.Item></LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/admin/excelhorasextra"><NavDropdown.Item>Excel de horas extra</NavDropdown.Item></LinkContainer>
            <LinkContainer to="/admin/excelgastos"><NavDropdown.Item>Excel de gastos</NavDropdown.Item></LinkContainer>
        </NavDropdown>
    );

    //#region Super Admin
    const forzarMailsFichaje = async () => {
        const ok = await swalertConfirm(
            "¿Seguro que quieres forzar los mails?",
            "Se volverán a mandar los mails para firmar los fichajes del último mes");
        if (ok) {
            apiGet("pdfs/forceRoutineLastMonth");
        }
    };
    const superAdmin = (
        <NavDropdown title="SuperAdmin" id="basic-nav-dropdown">
            <NavDropdown.Item className="txt-danger" onClick={forzarMailsFichaje}>Forzar email fichajes del mes</NavDropdown.Item>
        </NavDropdown>
    );
    //#endregion Super Admin

    const expand = (props.admin && props.validacion && props.vestuario) ? "lg" : (props.admin || props.validacion || props.vestuario) ? "lg" : "md";
    return (
        <Navbar collapseOnSelect expand={expand} className="bg-alt" variant="dark" sticky="top">
            <Container>
                <LinkContainer to="/"><Navbar.Brand>
                    <img src={logo} className="logo" alt="Logo SOGACSA" />
                </Navbar.Brand></LinkContainer>
                {props.min ? "" : (
                    <>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav" className="text-center">
                            <Nav className="me-auto">
                                <LinkContainer to="/fichajes"><Nav.Link>Fichajes</Nav.Link></LinkContainer>
                                <LinkContainer to="/diasLibres"><Nav.Link>Días Libres</Nav.Link></LinkContainer>
                                {solicitudes}
                                {props.admin || props.validacion ? validaciones : ""}
                                {props.vestuario ? vestuario : ""}
                                {props.admin || props.validacion ? supervision : ""}
                                {props.admin ? admin : ""}
                                {/*{props.nombre === "hugo.mendez" ? superAdmin : ""}*/}
                                <NavDropdown title="Info" id="basic-nav-dropdown">
                                    <LinkContainer to="/calendario"><NavDropdown.Item>Calendario</NavDropdown.Item></LinkContainer>
                                    <LinkContainer to="/docs"><NavDropdown.Item>Documentos</NavDropdown.Item></LinkContainer>
                                </NavDropdown>
                            </Nav>
                            <Nav>
                                <NavDropdown title={props.nombre} id="basic-nav-dropdown" align="end">
                                    <LinkContainer to="/perfil"><NavDropdown.Item>Mi perfil</NavDropdown.Item></LinkContainer>
                                    <NavDropdown.Item onClick={props.onLogout}>
                                        Cerrar sesión <FontAwesomeIcon icon={faRightFromBracket} title="Cerrar sesión" />
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </>
                )}
            </Container>
        </Navbar>
    );
}
